import { Component, OnInit } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams, IAfterGuiAttachedParams } from 'ag-grid-community';
import { BsModalService } from 'ngx-bootstrap/modal';
import { FrtShipmentHazmatModalComponent } from '../frt-shipment-item-modal/frt-shipment-item-modal.component';

@Component({
    selector: 'app-add-item-renderer',
    templateUrl: './add-item-renderer.component.html',
    styleUrls: ['./add-item-renderer.component.css'],
    standalone: false
})
export class AddItemRendererComponent implements AgRendererComponent, OnInit {
  params: any;
  refresh(params: any): boolean {
    throw new Error('Method not implemented.');
  }
  agInit(params: ICellRendererParams): void {
    this.params = params;
  }
  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
    throw new Error('Method not implemented.');
  }

  constructor(private modalService: BsModalService) { }

  ngOnInit() {
  }

  openItemInfoModal() { this.modalService.show(FrtShipmentHazmatModalComponent, { class: 'modal-lg' }); }

}
